// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"403ef6b2","669":"67ab2cee","872":"0928a568"}[chunkId] + ".chunk.js";
};